var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 5H4C2.89543 5 2 5.89543 2 7V8C2 8.55229 2.46 8.98368 2.98189 9.16437C4.15653 9.57105 5 10.687 5 12C5 13.313 4.15653 14.4289 2.98189 14.8356C2.46 15.0163 2 15.4477 2 16V17C2 18.1046 2.89543 19 4 19H15.25V17.25C15.25 16.8358 15.5858 16.5 16 16.5C16.4142 16.5 16.75 16.8358 16.75 17.25V19H20C21.1046 19 22 18.1046 22 17V16C22 15.4477 21.54 15.0163 21.0181 14.8356C19.8435 14.4289 19 13.313 19 12C19 10.687 19.8435 9.57105 21.0181 9.16437C21.54 8.98368 22 8.55229 22 8V7C22 5.89543 21.1046 5 20 5H16.75V6.75C16.75 7.16421 16.4142 7.5 16 7.5C15.5858 7.5 15.25 7.16421 15.25 6.75V5ZM16.75 10.25V13.75C16.75 14.1642 16.4142 14.5 16 14.5C15.5858 14.5 15.25 14.1642 15.25 13.75V10.25C15.25 9.83579 15.5858 9.5 16 9.5C16.4142 9.5 16.75 9.83579 16.75 10.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.b8ec9e99ea21561ef0c342929e43dd53.svg";
export { ForwardRef as ReactComponent };